export default __webpack_public_path__ + "locales/fr/SmartBanner.json?hash=c70f39336322a0cdee32a8d2b8f247ce";